import axios from 'axios';
import { Message } from 'element-ui'

function MyMessage(option) {
  Message.closeAll()
  Message(option)
}
MyMessage.error = function (option) {
  Message.closeAll()
  Message.error(option)
}
MyMessage.warning = function (option) {
  Message.closeAll()
  Message.warning(option)
}
const server = axios.create({
  // baseURL: 'http://101.37.25.211:8083',
  baseURL: process.env.BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截
server.interceptors.request.use(config => {
  let cookie = localStorage.getItem('sessionId');
  if (cookie) {
    config.headers.ncac_sessionId = cookie;
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// 添加一个响应拦截器
server.interceptors.response.use(function (res) {
  // 在这里对返回的数据进行处理
  if (res.data.title === '没有登录' || (res.data.query && res.data.query.title === '没有登录')) {
    localStorage.clear();
  }
  return res.data;
}, function (err) {
  // Do something with response error
  MyMessage.error('系统开了个小差，请稍后再试');
  return Promise.reject(err);
});

export default server
export const dataFormat = (function () {
  var rbracket = /\[\]$/;

  function buildParams(prefix, obj, traditional, add) {
    var name;

    if (Array.isArray(obj)) {

      // Serialize array item.
      obj.forEach(function (v, i) {

        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v);

        } else {

          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(
            prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
            v,
            traditional,
            add
          );
        }
      });

    } else if (!traditional && Object.prototype.toString.call(obj) === "[object Object]") {

      // Serialize object item.
      for (name in obj) {
        var prefixName = prefix ? prefix + "." + name : name;
        buildParams(prefixName, obj[name], traditional, add);
      }

    } else {

      // Serialize scalar item.
      add(prefix, obj);
    }
  }

  // Serialize an array of form elements or a set of
  // key/values into a query string
  return function param(a, traditional) {
    var prefix,
      s = [],
      add = function (key, value) {
        s[s.length] = encodeURIComponent(key) + "=" +
          encodeURIComponent(value == null ? "" : value);
      };

    if (a == null) {
      return "";
    }

    // If an array was passed in, assume that it is an array of form elements.
    if (Array.isArray(a)) {
      // Serialize the form elements
      a.forEach(function (v, i) {
        add(i, v);
      });

    } else {

      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    }

    // Return the resulting serialization
    return s.join("&");
  };
})()


// WEBPACK FOOTER //
// ./src/utils/request.js